const isFromMarketListForMapViewAB = (value: string | undefined): boolean => {
    if (!value) {
        return false;
    }
    const MARKETS = [
        'alaska',
        'arkansas',
        'hawaii',
        'iowa',
        'kansas',
        'nebraska',
        'new hampshire',
        'new mexico',
        'rhode island',
        'vermont',
    ];
    const searchValue = value.replace('-', ' ').toLowerCase();
    return MARKETS.indexOf(searchValue) !== -1;
};

export default isFromMarketListForMapViewAB;
